module.exports = __webpack_public_path__ + "img/zh_xdyl.9dd7e32a.svg";